import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftContentRightImg from "../../Components/sub-pages/Left-content-right-image";
import { Container } from "react-bootstrap";
import NogapleftImg from "../../Components/sub-pages/NogapleftImg";

const Rewardsandrecognition =()=>{
    const CTAContent = [
        {
          pageName: "Rewards & Recognition (R&R)",
          paragraphitalic: "Acknowledge Excellence and Drive Motivation ",
          paragraphText:
                "Celebrate milestones, achievements, and hard work with our Rewards & Recognition (R&R) Solutions. Whether it's rewarding top performers, celebrating anniversaries, or recognizing everyday contributions, our R&R programs offer a variety of meaningful gift options that motivate and inspire.",
          ContactFormName: "Rewards & Recognition (R&R)",
        },
      ];
    
      const SubpgesLeftContent = [
        {
          index: 0,
          sectionName: "Performance-Based Rewards",
          parapgraphItalic: "Motivate, Recognize, Excel",
          sectionparagraphText: (
            <>
              <p>
              Turn achievements into unforgettable moments with curated rewards. 
                </p>
                <p>
                Fuel your team’s drive for excellence with performance-based rewards that inspire and motivate. From tech gadgets and luxury accessories to exclusive experiences, these rewards are carefully designed to recognize exceptional efforts. Show your team that their contributions matter, and let every milestone feel like a grand accomplishment. 
              </p>
            </>
          ),
          ImgSrc: "../assests/images/Rewards & Recognition (R&R)/Performance-Based Rewards.jpg",
          
        },
    
        /**Catagory Img */
        {
          index: 1,
          sectionName: "Anniversary & Milestone Gifts",
          parapgraphItalic: "Celebrate Journeys, Cherish Milestones!",
          sectionparagraphText: (
            <>
              <p>
              Honor loyalty and achievement with thoughtful gifts for every milestone. 
                </p>
                <p>
                Mark the special occasions that define your team’s journey with personalized anniversary and milestone gifts. Whether it's a year of service, a company-wide success, or a personal achievement, our curated collection ensures each moment feels extraordinary. Strengthen bonds and create lasting memories with gifts that truly resonate.
              </p>
            </>
          ),
          ImgSrc: "../assests/images/Rewards & Recognition (R&R)/Anniversary & Milestone Gifts.jpg",
          categoryHeadingLeftSide: "Features That Celebrate Commitment",
          CategoriesLeftContent: [
            {
              CategoryImg: "../assests/images/Rewards & Recognition (R&R)/Personalized Keepsakes.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Personalized Keepsakes</b>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/Rewards & Recognition (R&R)/Luxury Gift Options.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Luxury Gift Options</b>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/Rewards & Recognition (R&R)/Custom Packaging.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Custom Packaging</b>
                  </p>
                </>
              ),
            },
          ],
        },
      ];
      const noGapContent = [
        {
          RightImgNogap: "../assests/images/Rewards & Recognition (R&R)/Features That Inspire Success.jpg",
          NogapHeading: "Features That Inspire Success",
          Heading: [
            {
              ListHeading: "Diverse Options",
              ListParagraph:
                "Choose from gadgets, gift cards, premium products, or experiences.",
            },
            {
              ListHeading: "Custom Branding",
              ListParagraph:
                "Add a personalized touch with your company’s logo and message.",
            },
            {
              ListHeading: "Flexible Packages",
              ListParagraph:
                "Tailored rewards to fit all levels of performance.",
            },
          ],
        },
        {
          RightImgNogap: "../assests/images/Rewards & Recognition (R&R)/Personalized Achievement Awards.jpg",
          NogapHeading: "Personalized Achievement Awards",
          paragraphItalic: "Turn Achievements into Timeless Treasures!",
          paragraphDetail: (
            <>
              <p>
                Recognize excellence with personalized awards that inspire greatness. 
                </p>
                <p>

                Celebrate exceptional accomplishments with achievement awards that leave a lasting impression. Designed with precision and elegance, these awards go beyond recognition—they inspire future success. Whether it’s an employee of the year trophy, a team award, or a leadership accolade, our bespoke designs make every recipient feel truly valued. 
              </p>
            </>
          ),
    
          NogapSubheading: "Features That Redefine Recognition",
          Categories: [
            {
              ServiceImg: "../assests/images/Rewards & Recognition (R&R)/Custom Engraving.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Custom Engraving</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/Rewards & Recognition (R&R)/Premium Materials.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Premium Materials</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/Rewards & Recognition (R&R)/Modern Designs.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Modern Designs</b>
                  </p>
                </>
              ),
            },
          ],
        },
      ];
    
  return (
    <>
      <Helmet>
        <title>eYantra Employee Recognition & Gifting</title>
        <meta name="description" content="eYantra offers employee recognition, branded merchandise, joining kits, and corporate gifts in Hyderabad, including welcome kits and thoughtful employee gifts."/>
        <meta name="keywords" content="eyantra, employee recognition, reward and recognition, branded merchandise, corporate gifting, joining kits,  corporate gifts, corporate gifts for employees, welcome kits"/>
      </Helmet>
      <div className="p-0 m-2">
      <Ctapage data={CTAContent} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[0]} />
      </Container>
      <NogapleftImg data={noGapContent[0]} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[1]} />
      </Container>
      <NogapleftImg data={noGapContent[1]} />
      </div>

      <p className="text-center fs-32 w-75 d-block m-auto py-5">
        From experiential rewards to tangible tokens of appreciation, our R&R solutions are designed to make your team feel recognized and valued every step of the way.
      </p>
    </>
  );
};

export default Rewardsandrecognition;